import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import {
  type GroupNode,
  NgDiagramGroupHighlightedDirective,
  type NgDiagramGroupNodeTemplate,
  NgDiagramNodeResizeAdornmentComponent,
  NgDiagramNodeSelectedDirective,
  NgDiagramPortComponent,
} from 'ng-diagram'
import { DaydicTypesIconNames, Media } from 'src/app/shared/enums/enums'
import { Figure } from 'src/app/shared/models/main/figure'

export interface GroupNodeData {
  figure: Figure
}

@Component({
  selector: 'ddc-canvas-node-figure',
  imports: [
    NgDiagramPortComponent,
    NgDiagramNodeSelectedDirective,
    NgDiagramGroupHighlightedDirective,
    CommonModule,
    NgDiagramNodeResizeAdornmentComponent,
    MatIcon,
  ],
  templateUrl: './figure-node.component.html',
  styleUrls: ['./figure-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.ng-diagram-port-hoverable]': 'true',
  },
})
export class CanvasFigureNodeComponent implements NgDiagramGroupNodeTemplate<GroupNodeData> {
  node = input.required<GroupNode<GroupNodeData>>()
  title = signal<string>('Figure')
  icon = signal<string>(DaydicTypesIconNames.FIGURE)

  figurePicUrl = computed(() => {
    const url = this.node()?.data?.figure.figure_pic
    if (!url) return ''
    if (url.startsWith('http')) {
      const mediaIndex = url.indexOf('/media/')
      return mediaIndex !== -1 ? Media.ASSETS + url.slice(mediaIndex) : url
    }
    return Media.ASSETS + url
  })
}
